import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useStyles } from './styles'
import { DataUsageList } from '@/shared/ui/dataUsageList'
import { AppButton } from '@/shared/ui/button'
import WebApp from '@twa-dev/sdk'
import { Icon } from '../icon'

type GamedDataUsageProps = {
  onClick: () => void
}

export const GamedDataUsage = (props: GamedDataUsageProps) => {
  const userLang = useUnit($userLanguage)
  const { onClick } = props
  const texts = lang[userLang].pages.authPage.data_using
  const { classes } = useStyles()

  const handlePrivacyClick = () => {
    WebApp.openLink('https://telegra.ph/PRIVACY-POLICY-01-09-58', { try_instant_view: true })
  }

  const handleTermsClick = () => {
    WebApp.openLink('https://telegra.ph/GAMED-TERMS-of-SERVICE-01-09', { try_instant_view: true })
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.headingWrapper}>
          <Icon
            view="steam"
            width={28}
          />
          <h1>{texts.heading}</h1>
        </div>
        <span className={classes.paragraph}>{texts.parapraph}</span>
        <span className={classes.whatWeCollect}>{texts.what_we_collect}</span>
        <div style={{ zIndex: 5 }}>
          <DataUsageList />
        </div>

        <span className={classes.policy}>
          {texts.privacy_policy.for_more_info}&nbsp;
          <a onClick={handlePrivacyClick}>{texts.privacy_policy.privacy_policy}</a> {texts.privacy_policy.and}{' '}
          <a onClick={handleTermsClick}>{texts.privacy_policy.terms_of_service}</a>
        </span>
      </div>
      <div
        className={classes.buttonWrapper}
        style={{
          marginBottom: WebApp.platform == 'ios' ? '2vh' : '0px',
        }}
      >
        <AppButton
          className={classes.button}
          onClick={onClick}
        >
          {lang[userLang].pages.btnTexts.back}
        </AppButton>
      </div>
      <div className={classes.blackBackground}></div>
      <div className={classes.buttonShadow}></div>
    </>
  )
}
